import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
// models
import { ModalID, StatusModalIndicator } from '../../models/constants';
import { SalesItem } from '../../models/accounting';
import { SharedService } from '../../services/shared.service';
import { AvailableFirearm } from '../../models/general';
// Services

@Component({
  selector: 'app-serial-number-list',
  templateUrl: './serial-number-list.component.html',
  styleUrls: ['./serial-number-list.component.scss'],
  standalone: true,
  imports: [NgSelectModule],
})
export class SerialNumberListComponent implements OnDestroy {
  @Input() context: any;
  item_count: number;
  saleItem: SalesItem;
  rowIndex: number;
  selected_serial_numbers: string[] = [];
  available_firearms_for_dispo_filtered: AvailableFirearm[] = [];

  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  modalOptions: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    class: 'modal-dialog modal-dialog-centered',
  } as any;

  constructor(
    protected element: ElementRef,
    private sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    console.log(this.item_count, this.saleItem, this.rowIndex);
    console.log(this.sharedService.available_firearms_for_dispo);
    this.available_firearms_for_dispo_filtered =
      this.sharedService.available_firearms_for_dispo.filter(
        (firearm) => firearm.firearm_upc === this.saleItem?.product_service,
      );
    this.available_firearms_for_dispo_filtered = [
      ...this.available_firearms_for_dispo_filtered,
    ];
    console.log(this.available_firearms_for_dispo_filtered);
  }

  closeModalClick(): void {
    this.sharedService.closeModal(ModalID.firearm_serial_number_list);
  }

  selectionChanged(event: any, index: number) {
    console.log('selectionChanged');
    console.log(event, index);
    console.log(this.selected_serial_numbers);
  }

  saveSelections() {
    console.log('saveSelections');
    console.log(this.selected_serial_numbers);
    this.sharedService.closeModal(ModalID.firearm_serial_number_list);
  }
  ngOnDestroy() {
    //    this.sub.unsubscribe();
  }
}
